// Container Unit Price Rule API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ContainerUnitPriceRuleRequests = {
    create: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<{id: number}>,
    get: RequestConfigFunction<{id: number}>,
}

const containerUnitPriceRuleRequests: ContainerUnitPriceRuleRequests = {
    create: () => {
        return {
            method: 'POST',
            url: 'containerunitpricerule',
        }
    },
    update: ({
        id,
    }) => {
        return {
            method: 'PATCH',
            url: `containerunitpricerule/${id}`,
        }
    },
    get: ({
        id,
    }) => {
        return {
            method: 'GET',
            url: `containerunitpricerule/${id}`,
        }
    },
}

export default containerUnitPriceRuleRequests
